function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
import { Link } from 'react-router-dom';
import { Flex } from '@finect/tabular-core/Flex';
import { NEW_ITEMS, PORTAL_SECTION_MAX_STOREFRONTS, PORTAL_SECTION_MAX_FAMILIES } from '../../data';
import { Title, NavLink } from '../partials';
import { Highlight } from '../../partials/MenuList';
export const NavMenuSection = _ref => {
  let {
    title,
    link: titleLink,
    entities,
    finectApp,
    onLinkClick
  } = _ref;
  const {
    items,
    type
  } = entities;
  return React.createElement(Flex, {
    direction: "column"
  }, title ? React.createElement(Title, titleLink ? finectApp === 'front-products' ? {
    to: titleLink,
    as: Link
  } : {
    href: titleLink,
    as: 'a'
  } : {}, title) : null, type === 'storefront' ? React.createElement("ul", null, items.slice(0, PORTAL_SECTION_MAX_STOREFRONTS).map((storefront, index) => {
    const hasMainCategory = storefront.categories.find(item => item.type === 'main');
    const link = storefront.alias === 'roboadvisors' ? '/usuario/Kaloxa/articulos/comparativa-roboadvisors-carteras-indexadas' : hasMainCategory ? "/fondos-inversion/categorias/".concat(hasMainCategory.id, "-").concat(hasMainCategory.alias) : "/invertir/".concat(storefront.alias);
    const linkProps = finectApp === 'front-products' && storefront.alias !== 'roboadvisors' ? {
      to: link,
      as: Link
    } : {
      href: link
    };
    return React.createElement("li", {
      key: index,
      onClick: onLinkClick
    }, React.createElement(NavLink, _extends({
      "data-fi-event": "omninav-mainMenu",
      title: storefront.title
    }, linkProps), storefront.title));
  })) : null, type === 'link' ? React.createElement("ul", null, items.map((item, index) => {
    const betweenArticles = typeof window !== 'undefined' && window.location.pathname.includes('/articulos') && item.link.includes('/articulos');
    const linkProps = finectApp === 'front-products' && !betweenArticles ? {
      to: item.link,
      as: Link
    } : {
      href: item.link
    };
    return React.createElement("li", {
      key: index,
      onClick: onLinkClick
    }, React.createElement(NavLink, _extends({
      "data-fi-event": "omninav-mainMenu",
      title: item.title
    }, linkProps), React.createElement("span", null, item.title, NEW_ITEMS.includes(item.type) && React.createElement(Highlight, null, "Nuevo"))));
  })) : null, type === 'productFamily' ? React.createElement("ul", null, items.map((item, index) => {
    const {
      productType
    } = item;
    const isHighlighted = NEW_ITEMS.includes(item.type);
    if (productType.views.includes('home')) {
      const link = "/".concat(productType.slug);
      const linkProps = finectApp === 'front-products' && ['content', 'iic'].includes(productType.category) ? {
        to: link,
        as: Link
      } : {
        href: link
      };
      return React.createElement("li", {
        key: index,
        onClick: onLinkClick
      }, React.createElement(NavLink, _extends({
        "data-fi-event": "omninav-mainMenu",
        title: productType.plural
      }, linkProps), React.createElement("span", null, productType.plural, isHighlighted && React.createElement(Highlight, null, "Nuevo"))));
    }
    if (productType.tag) {
      const link = "/invertir/".concat(productType.tag);
      const linkProps = finectApp === 'front-products' ? {
        to: link,
        as: Link
      } : {
        href: link
      };
      return React.createElement("li", {
        key: index,
        onClick: onLinkClick
      }, React.createElement(NavLink, _extends({
        "data-fi-event": "omninav-mainMenu",
        title: productType.plural
      }, linkProps), React.createElement("span", null, productType.plural, isHighlighted && React.createElement(Highlight, null, "Nuevo"))));
    }
    return null;
  }).filter(component => Boolean(component)).slice(0, PORTAL_SECTION_MAX_FAMILIES)) : null);
};